var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewupdateTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 73,
    viewBox: "0 0 80 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4347 52.2729C20.451 60.8764 31.0216 65.7565 42.0448 63.1731C53.0679 60.5897 60.3694 51.5209 58.353 42.9175C56.3367 34.3141 45.7661 29.4339 34.743 32.0173C23.7198 34.6007 16.4183 43.6695 18.4347 52.2729Z",
    fill: "#FFB858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9412 71.3002L8.56373 49.8573L18.314 36.432L32.2259 44.1005L39.361 51.5665L43.2735 41.3311L51.2848 39.1483L56.7885 27.415L78.7031 55.0662L13.9412 71.3002Z",
    fill: "#E6570E",
    stroke: "#FFB858",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7324 28.5092C45.5394 26.3881 48.2663 26.0556 48.0732 23.9345C47.8802 21.8134 45.1533 22.1458 44.9602 20.0247C44.7672 17.9036 47.4941 17.5712 47.301 15.4501C47.108 13.329 44.3811 13.6614 44.188 11.5403C43.995 9.41923 46.7219 9.08679 46.5288 6.96569",
    stroke: "#FFB858",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9268 29.0233C35.3125 26.9877 37.9568 26.2297 37.3425 24.1941C36.7283 22.1585 34.084 22.9165 33.4698 20.881C32.8555 18.8454 35.4998 18.0873 34.8855 16.0517C34.2713 14.0161 31.6271 14.7742 31.0128 12.7386C30.3986 10.703 33.0428 9.94495 32.4286 7.90936",
    stroke: "#FFB858",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.502 33.3215C24.4292 31.4638 26.875 30.2478 25.8022 28.39C24.7294 26.5322 22.2836 27.7483 21.2109 25.8905C20.1381 24.0328 22.5839 22.8167 21.5111 20.959C20.4383 19.1012 17.9925 20.3172 16.9198 18.4595C15.847 16.6017 18.2928 15.3857 17.22 13.528",
    stroke: "#FFB858",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewupdateTag);
export default __webpack_public_path__ + "static/media/newupdate-tag.e1dca57168751dc45f75b340c9e54ef6.svg";
export { ForwardRef as ReactComponent };